import { Component, OnInit } from '@angular/core';
import { UsersService } from 'src/app/shared/services/users.service';
import { GeneralInfo } from "../../shared/models/info.model";
import {DomSanitizer} from "@angular/platform-browser";

@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.scss']
})
export class ContactsComponent implements OnInit {

  generalInfo: GeneralInfo;

  constructor(private usersService: UsersService, private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.getGeneralInfo();
  }

  getGeneralInfo() {
    this.usersService.getGeneralInfo().subscribe(data => {
      this.generalInfo = data;
    })
  }

  getTrustedHtml(text: string) {
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }

}
